export default function Hero() {
  const scrollToApplication = () => {
    const applicationSection = document.getElementById('application');
    if (applicationSection) {
      applicationSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/bf0c85f63d4026a4a5aa9d120dd03524.jpg)'
        }}
      />
      
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>

      {/* Content */}
      <div className="relative z-10 mx-auto max-w-5xl px-5 sm:px-6 py-32 text-center w-full">
        <div className="mb-8 h-px w-32 mx-auto bg-gradient-to-r from-transparent via-amber-400 to-transparent" />
        
        <h1 className="mb-6 font-serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-light leading-tight text-white px-4">
          Vancouver's most exclusive,<br />
          <span className="italic">invite-only social network</span>
        </h1>

        <p className="mb-10 text-lg sm:text-xl md:text-2xl lg:text-3xl font-medium text-amber-400 px-4">
          Membership is by invitation only.
        </p>
        
        <button
          onClick={scrollToApplication}
          className="mb-10 bg-amber-400 px-8 sm:px-12 md:px-16 lg:px-20 py-5 sm:py-6 text-base sm:text-lg md:text-xl font-semibold tracking-widest text-black transition-all duration-300 hover:bg-amber-500 hover:scale-105 whitespace-nowrap cursor-pointer shadow-2xl mx-4"
        >
          APPLY FOR MEMBERSHIP
        </button>
        
        <p className="text-base sm:text-lg md:text-xl lg:text-2xl leading-relaxed text-gray-200 px-4">
          Join Vancouver's elite community of successful influencers, models, entrepreneurs, and high-status individuals.
        </p>

        {/* Scroll Indicator */}
        <div className="mt-20 flex flex-col items-center gap-3">
          <div className="text-sm uppercase tracking-widest text-gray-300">Scroll to explore</div>
          <div className="flex h-10 w-6 items-center justify-center border border-gray-400">
            <div className="h-2 w-px animate-bounce bg-amber-400"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
